module.exports = __webpack_public_path__ + "static/media/0021.8bb28097.jpg";